import React from 'react';
import { Flex, FlexItem, Spinner } from '@patternfly/react-core';
import DialGraphComponent from './DialGraphComponent';
import PropTypes from 'prop-types';
import _ from 'lodash';

const DialPanelList = ({ signalData, dialOptions, gaugeHeight, valueFormatter, isLoading, header = null, plotlines }) => {
  if (isLoading) {
    return <Spinner size="md"/>;
  }
  return (
    <>
      { header }
      <Flex >
        { _.map(signalData, (signal) => {
          return (
            <FlexItem key={`${signal.assetId}-${signal.signalId}`}>
              <div style={{ width: `${1.35 * gaugeHeight}px`, height: `${gaugeHeight}px` }}>
                <div className={'dial-panel-container'}>
                  <DialGraphComponent
                    signal={signal}
                    options={dialOptions}
                    valueFormatter={valueFormatter ?? ''}
                    plotlines={plotlines}
                  />
                </div>
              </div>
            </FlexItem>

          );
        }) }
      </Flex>
    </>
  );
};

DialPanelList.propTypes = {
  dialOptions: PropTypes.object.isRequired,
  gaugeHeight: PropTypes.number.isRequired,
  valueFormatter: PropTypes.string,
  isLoading: PropTypes.bool,
  header: PropTypes.string
};

export default DialPanelList;
